<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <dialog-table-page ref="tradeTable" :pageData="tradePageData"></dialog-table-page>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import Url from '@/views/crs36/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import dialogTablePage from '@/components/page/dialogTable.vue'
import Qs from 'qs'

let status = { 1: '未开始', 2: '进行中', 3: '已结束', 4: '待审核' }
export default {
  name: 'user',
  components: {
    tablePage,
    FORM,
    dialogTablePage
  },
  methods: {
    checkbox(row) {
      this.applyId = row.map(key => key.id).join(',')
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'apply') {
        this.dataChanage(Url.commission.user.apply, { ids: row.id }, res => {
          if (res.code == 0) {
            this.$message.success('suc')
            this.$refs.childTable.defaultGetData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'end') {
        this.dataChanage(Url.commission.user.end, { id: row.id }, res => {
          if (res.code == 0) {
            this.$message.success('suc')
            this.$refs.childTable.defaultGetData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      } else if (clickName == 'trade') {
        this.tradePageData.sync = true
        let model = {
          account: row.account,
          endTime: row.endTime,
          startTime: (row.startTime > row.approvalTime ? row.startTime : row.approvalTime)
        }
        this.$refs.tradeTable.defaultQueryData(model)
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName || window.$t('crs36.bt.search') == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      } else if ('批量审批' == clickName) {
        this.dataChanage(Url.commission.user.apply, { ids: this.applyId }, res => {
          if (res.code == 0) {
            this.$message.success('suc')
            this.$refs.childTable.defaultGetData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    dataChanage(url, option, suc, fail) {
      this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }
  },
  data() {
    return {
      applyId: '',
      queryData: {},
      /*新增或更新*/
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: '活动id', field: 'activeId', data: this.$route.query.activeId },
          { title: '层级id', field: 'levelId' },
          { title: '层级名称', field: 'name' },
          { title: '客户账号', field: 'account' },
          { click: '查询', auth: 'crs36.commission.user.query' },
          { click: '批量审批', confirm: true, auth: 'crs36.commission.user.apply' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.commission.user.query, //请求路径和参数
        sequence: true,
        cols: [
          { title: '活动id', field: 'activeId' },
          { title: '层级id', field: 'levelId' },
          { title: '层级名称', field: 'name' },
          { title: '客户账号', field: 'account' },
          {
            title: '状态', field: 'status', render: (data, full) => {
              return status[data]
            }
          },
          { title: '交易手数', field: 'total', h5Click: 'trade' },
          { title: '交易佣金', field: 'commission' },
          { title: '返现金额', field: 'amount' },
          {
            title: '结算时间', field: 'closeTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '活动开始时间', field: 'startTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '活动结束时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '创建时间', field: 'endTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '审批时间', field: 'approvalTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '创建者', field: 'creator' },
          { title: '审批人', field: 'approval' },
          { title: '结算人', field: 'end' },
          {
            title: window.$t('crs36.bt.operation'), width: 100, btnClick: [
              {
                name: '审批',
                click: 'apply',
                type: 'primary',
                icon: 'el-icon-edit',
                confirm: true,
                hidden: (data, full) => {
                  return full.status != 4
                },
                auth: 'crs36.commission.user.apply'
              },
              {
                name: '结算',
                click: 'end',
                type: 'primary',
                icon: 'el-icon-edit',
                confirm: true,
                hidden: (data, full) => {
                  return full.status != 2
                },
                auth: 'crs36.commission.user.end'
              }
            ]
          }
        ]
      },
      tradePageData: {
        queryUrl: Url.commission.trade.query, //请求路径和参数
        sequence: true,
        sync: false,
        cols: [
          { title: '用户账号', field: 'account' },
          { title: '同步数据id', field: 'synId' },
          { title: 'positionId', field: 'positionId' },
          { title: '交易产品', field: 'symbol' },
          { title: '手数', field: 'volume' },
          { title: '佣金', field: 'commission' },
          { title: '交易平台', field: 'platform' },
          { title: '日期（天）', field: 'day' },
          {
            title: '交易时间', field: 'time', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          }
        ]
      }
    }
  }
}
</script>

